
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { gameMetaArray } from 'db/data';
import { Carousel, Flex, Typography, Image } from 'antd';
import { ImagePlayer } from 'components/ImagePlayer';
import { YoutubeVideoEmbed } from 'components/YoutubeVideoEmbed';
import { DrawerButton } from 'components/DrawerButton';
import { OverlayComp } from 'components/OverlayComp';
import { Parallax, Background } from 'react-parallax';
import { ContactsList } from 'components/ContactsList';
export const AboutPage: React.FC = () => (
	<>
		<Parallax blur={5} bgImage={require('images/banner6.png')} strength={0}>
			<Flex vertical justify="center" style={{ textAlign: 'center', padding: '80px', height: 540 }}>
				<Typography.Title style={{ color: 'white' }}>Groups of people who create games</Typography.Title>
			</Flex>
		</Parallax>
		<Flex gap={30} vertical justify="center" style={{ textAlign: 'center', margin: "150px 50px" }}>
			<Typography.Title>Kaptis Interactive</Typography.Title>
			<Typography.Paragraph strong>
				Kaptis are small indie game creators. Our first game release was in 2022. Our dream is to form a global teams creating games that can be play by many. 
				Our goal environment is to have developer forming teams with people they want to work best with, coming up with new ideas. We want teams to be independent and freely on their own. 
			</Typography.Paragraph>
			<ContactsList/>
		</Flex>
	</>
);

